module.exports = __webpack_public_path__ + "static/media/picker.0193aafa.png";